"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _utils = require("../../../lib/utils");

var _constants = require("@evdy/web-redux/dist/constants");

var _classnames = _interopRequireDefault(require("classnames"));

require("../../../sass/components/shared/elements/AppLinks.css");

var _dec, _class;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var bucket = 'https://everdays-site.s3.amazonaws.com/share';
var appStoreBtn = "".concat(bucket, "/appstore-black.svg");
var googlePlayBtn = "".concat(bucket, "/googleplay-black.svg");
var appStoreIconWhite = "".concat(bucket, "/appstore-white.svg");
var playStoreIconWhite = "".concat(bucket, "/googleplay-white.svg");
var AppLinks = (_dec = (0, _reactRedux.connect)(function (_ref) {
  var mobileOS = _ref.mobileOS;
  return {
    mobileOS: mobileOS
  };
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(AppLinks, _React$Component);

  var _super = _createSuper(AppLinks);

  function AppLinks() {
    _classCallCheck(this, AppLinks);

    return _super.apply(this, arguments);
  }

  _createClass(AppLinks, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          white = _this$props.white,
          os = _this$props.mobileOS.os,
          isRow = _this$props.isRow;
      var downloadLinkClasses = (0, _classnames.default)('app-modal-store-links', {
        'display-row': isRow
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: downloadLinkClasses
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.APPLE_LINK,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (0, _utils.googleAnalytics)('apple_store')
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "app-modal-apple-store",
        src: white ? appStoreIconWhite : appStoreBtn,
        alt: "Download Everdays on Apple App Store"
      })), /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.GOOGLE_LINK,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: (0, _utils.googleAnalytics)('google_store')
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "app-modal-google-store",
        src: white ? playStoreIconWhite : googlePlayBtn,
        alt: "Download Everdays on Google Play Store"
      })));
    }
  }]);

  return AppLinks;
}(_react.default.Component)) || _class);
exports.default = AppLinks;